import type { WorkflowNode } from '../../../types/workflow';
import type { AvailableSandboxAction } from '../../../hooks/useAvailableSandboxActions';

/**
 * Derives sensitive keys from a loaded sandbox action schema.
 * Undefined means the schema is unknown, so the canvas masks every param.
 */
export function deriveSandboxActionSensitivity({
  nodes,
  sandboxActions,
}: {
  nodes: WorkflowNode[];
  sandboxActions: AvailableSandboxAction[];
}): WorkflowNode[] {
  return nodes.map((node) => {
    if (node.type !== 'sandbox_action') return node;

    const data = node.data as Record<string, unknown> | undefined;
    const actionSlug = typeof data?.actionSlug === 'string' ? data.actionSlug : null;
    const action = sandboxActions.find((candidate) => candidate.slug === actionSlug);
    const sensitiveParams = action
      ? Object.entries(action.inputSchema.properties)
          .filter(([, property]) => property.sensitive === true)
          .map(([key]) => key)
      : undefined;

    return {
      ...node,
      data: {
        ...data,
        sensitiveParams,
      },
    };
  });
}
